/**
 * La forma con cui un errore del dominio ZDHC arriva a chi ha chiamato.
 *
 * **Perche' non e' piu' un elenco di campi.** Era un allowlist — `error`,
 * `status`, `message`, `errors` — e ogni rifiuto strutturato nuovo doveva
 * ricordarsi di aggiungere il suo. Chi lo dimenticava non rompeva niente in
 * modo visibile: la richiesta funzionava, il codice d'errore arrivava, e
 * spariva solo il **contenuto** che rendeva il messaggio leggibile. Nessun
 * test lo intercettava, perche' i test stavano sul produttore e sul consumatore
 * finale e l'elenco sta in mezzo.
 *
 * E' successo due volte di fila, sugli unici due rifiuti che hanno un payload:
 * `conflict` di `already_associated_to_another_product` e `duplicates` di
 * `zdhc_duplicate_product_lines`. La seconda l'ha trovata una review, non un
 * test.
 *
 * Quindi il corpo passa **per intero**, e i quattro campi normalizzati si
 * riscrivono sopra: `error` con il suo fallback quando il server non ne manda
 * uno, e `status` che e' quello **HTTP** e vince su un eventuale omonimo nel
 * corpo — com'era prima, perche' il `status` del corpo (`'error'`) non e' mai
 * stato esposto. Da qui in avanti un rifiuto nuovo non deve ricordarsi di
 * niente.
 *
 * Sta in un modulo suo, e non dentro la closure di `ZdhcService`, perche' li'
 * non era importabile: provarlo voleva `useApi` e `useStore`, cioe' un
 * componente montato. Qui un harness lo prova con il corpo vero dell'api.
 *
 * @param {object} e l'errore axios
 * @returns {object} `{ ...corpo, error, status, message, errors }`
 */
export const normalizeError = (e) => ({
    ...(e?.response?.data && typeof e.response.data === 'object' ? e.response.data : {}),
    error: e?.response?.data?.error ?? 'zdhc_unreachable',
    status: e?.response?.status ?? null,
    message: e?.response?.data?.message ?? null,
    errors: e?.response?.data?.errors ?? null,
});

export default normalizeError;
